import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const ImpactPage = () => {
  const stats = [
    { number: "100+", label: "Lives Touched", icon: "👥" },
    { number: "24/7", label: "Support Available", icon: "🕐" },
    { number: "5+", label: "Years of Service", icon: "📅" },
    { number: "50+", label: "Community Programs", icon: "🎯" }
  ];

  const impactAreas = [
    {
      title: "Individual Empowerment",
      description: "Supporting survivors to reclaim their agency, rebuild resilience, and heal emotionally through compassionate psychological care.",
      icon: "💪"
    },
    {
      title: "Community Transformation",
      description: "Creating awareness and reducing stigma around mental health and violence, fostering supportive communities.",
      icon: "🌍"
    },
    {
      title: "Sustainable Change",
      description: "Building long-term capacity through education, training, and partnerships that create lasting positive impact.",
      icon: "🌱"
    }
  ];

  return (
    <div className="impact-page">
      <div className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <div className="page-badge">Our Impact</div>
            <h1 className="page-title-animated">Making a Difference</h1>
            <p className="page-subtitle">
              Transforming lives and communities through compassionate support and sustainable programs
            </p>
          </div>
        </div>
      </div>

      <div className="container page-content">
        <section className="impact-intro">
          <div className="overview-content">
            <h2 className="overview-title">About CAEI</h2>
            <div className="overview-text">
              <p>
                Community Awareness and Empowerment Initiative (CAEI) is dedicated to providing compassionate support for individuals affected by violence, with a focus on psychological healing and empowerment.
              </p>
              <p>
                We stand with survivors of violence and abuse in Tanzania, listening without judgment, affirming their worth, and offering compassionate psychological care. Our goal is to help survivors reclaim agency, rebuild resilience, and heal emotionally.
              </p>
              <p className="highlight-text">
                Through evidence-based interventions and community partnerships, we are creating lasting change and building a more supportive, inclusive society.
              </p>
            </div>
          </div>
        </section>

        <section className="stats-section">
          <h2 className="section-title-centered">Our Impact in Numbers</h2>
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div className="stat-card" key={index}>
                <div className="stat-icon-large">{stat.icon}</div>
                <div className="stat-number-large">{stat.number}</div>
                <div className="stat-label-large">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="impact-areas-section">
          <h2 className="section-title-centered">Areas of Impact</h2>
          <div className="impact-areas-grid">
            {impactAreas.map((area, index) => (
              <div className="impact-area-card" key={index}>
                <div className="impact-icon">{area.icon}</div>
                <h3>{area.title}</h3>
                <p>{area.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="impact-image-section">
          <div className="impact-visual">
            <img src="about.png" alt="Community Support" />
          </div>
        </section>

        <div className="page-nav-footer">
          <Link to="/" className="btn btn-primary">← Back to Home</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ImpactPage;
